var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNeedsSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 45.804 26.719"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.268 24.81a1.908 1.908 0 011.908-1.91h11.451a1.908 1.908 0 110 3.817H17.176a1.908 1.908 0 01-1.908-1.907zM7.634 13.359a1.909 1.909 0 011.909-1.909h26.718a1.908 1.908 0 010 3.817H9.542a1.908 1.908 0 01-1.908-1.908zM0 1.909A1.909 1.909 0 011.908 0H43.9a1.908 1.908 0 010 3.817H1.908A1.908 1.908 0 010 1.909z",
    fill: "#FF6C00",
    fillRule: "evenodd"
  })));
}

export default SvgIconNeedsSearch;